/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Shape emitted by the `GET /challenges/:slug/community-goal` endpoint
 * and embedded in `Challenge` responses. Public-safe — never includes
 * `rewardConfigId` (the internal pointer to the reward pool) or
 * `sharedUnlockCode` unless `unlockedAt` is set AND the caller is
 * authenticated. Resolution of `sharedUnlockCode` happens at the
 * endpoint layer, not inside the model's `prepareForResponse`.
 * 
 * @export
 * @interface ChallengeCommunityGoalResponse
 */
export interface ChallengeCommunityGoalResponse {
    /**
     * 
     * @type {number}
     * @memberof ChallengeCommunityGoalResponse
     */
    current: number;
    /**
     * 
     * @type {number}
     * @memberof ChallengeCommunityGoalResponse
     */
    target: number;
    /**
     * 
     * @type {number}
     * @memberof ChallengeCommunityGoalResponse
     */
    lastSyncAt?: number;
    /**
     * 
     * @type {string}
     * @memberof ChallengeCommunityGoalResponse
     */
    rewardImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeCommunityGoalResponse
     */
    rewardName?: string;
    /**
     * Unix ms when the goal first met `current >= target`. Stamped once by the god-admin sync endpoint; never re-cleared. Never writable through the Challenge body.
     * @type {number}
     * @memberof ChallengeCommunityGoalResponse
     */
    unlockedAt?: number;
    /**
     * Resolved bulk unlock code. Only present once `unlockedAt` is set AND the request was authenticated. Not a stored field.
     * @type {string}
     * @memberof ChallengeCommunityGoalResponse
     */
    sharedUnlockCode?: string;
}

/**
 * Check if a given object implements the ChallengeCommunityGoalResponse interface.
 */
export function instanceOfChallengeCommunityGoalResponse(value: object): value is ChallengeCommunityGoalResponse {
    if (!('current' in value) || value['current'] === undefined) return false;
    if (!('target' in value) || value['target'] === undefined) return false;
    return true;
}

export function ChallengeCommunityGoalResponseFromJSON(json: any): ChallengeCommunityGoalResponse {
    return ChallengeCommunityGoalResponseFromJSONTyped(json, false);
}

export function ChallengeCommunityGoalResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeCommunityGoalResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'current': json['current'],
        'target': json['target'],
        'lastSyncAt': json['lastSyncAt'] == null ? undefined : json['lastSyncAt'],
        'rewardImageUrl': json['rewardImageUrl'] == null ? undefined : json['rewardImageUrl'],
        'rewardName': json['rewardName'] == null ? undefined : json['rewardName'],
        'unlockedAt': json['unlockedAt'] == null ? undefined : json['unlockedAt'],
        'sharedUnlockCode': json['sharedUnlockCode'] == null ? undefined : json['sharedUnlockCode'],
    };
}

export function ChallengeCommunityGoalResponseToJSON(json: any): ChallengeCommunityGoalResponse {
    return ChallengeCommunityGoalResponseToJSONTyped(json, false);
}

export function ChallengeCommunityGoalResponseToJSONTyped(value?: ChallengeCommunityGoalResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'current': value['current'],
        'target': value['target'],
        'lastSyncAt': value['lastSyncAt'],
        'rewardImageUrl': value['rewardImageUrl'],
        'rewardName': value['rewardName'],
        'unlockedAt': value['unlockedAt'],
        'sharedUnlockCode': value['sharedUnlockCode'],
    };
}

